   document.addEventListener('DOMContentLoaded', function() {
    new Swiper('.hhjgkj', {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      grabCursor: true,
      // autoplay: {
      //   delay: 4000,
      //   disableOnInteraction: false,
      // },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  });
 
 
// document.addEventListener('DOMContentLoaded', function() {
//   const slider = document.querySelector('#GalleryViewer-template--19077601656998__main ul.slider');
//   const slides = slider.querySelectorAll('.slider__slide');
//   const prevBtn = document.querySelector('.slider-button--prev');
//   const nextBtn = document.querySelector('.slider-button--next');
//   const counterCurrent = document.querySelector('.slider-counter--current');
//   let current = 0;

//   function updateSlide(index) {
//     slides.forEach((slide, i) => {
//       slide.classList.toggle('is-active', i === index);
//       slide.style.transform = `translateX(${(i - index) * 100}%)`;
//     });
//     counterCurrent.textContent = index + 1;
//   }

//   prevBtn.addEventListener('click', () => {
//     current = (current - 1 + slides.length) % slides.length;
//     updateSlide(current);
//   });

//   nextBtn.addEventListener('click', () => {
//     current = (current + 1) % slides.length;
//     updateSlide(current);
//   });

//   // Initialize
//   updateSlide(current);
// });
 
